import React from "react"
import { constants } from "../../Constants"
import SaayaLogo from "../../static/images/saaya-logo-new.png"

export function UnAuthenticatedHeader({ faq_active }) {
    return (
        <div>
            {faq_active ?
                <div className='sh-faq-header'>
                    <a href='/'>
                        <div className="sh-hl-logo">
                            <img src={SaayaLogo} />
                        </div>
                    </a>
                    <div className="sh-faq-link">
                        <div><a target={"_blank"} href='https://saayahealth.com/blog'>{constants.VIEW_BLOGS}</a></div>
                        <div><a className='faq-active'>{constants.FAQ_TXT}</a></div>
                    </div>
                </div>
                :
                <div className='sh-login-header'>
                    <div><a target={"_blank"} href='https://saayahealth.com/blog'>{constants.VIEW_BLOGS}</a></div>
                    <div><a href='/faq'>{constants.FAQ_TXT}</a></div>
                </div>
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/HeaderUnAunthicated/index.js